import { Directive } from '@angular/core';
import { IfCheckoutProcessDirectiveDef } from '@df/ui/common/if-checkout-process.directive.def';
@Directive({
    selector: '[ifCheckoutProcess]',
    standalone: true
})
export class IfCheckoutProcessDirective extends IfCheckoutProcessDirectiveDef {
    protected check(): boolean {
        const url = this.router.url;
        return (!!(url.match(/^\/checkout/) || !!url.match(/^\/sample-checkout/)) &&
            !url.match(/^\/checkout\/success/) &&
            !url.match(/^\/sample-checkout\/success/));
    }
}
